export default __webpack_public_path__ + "static/media/534.912bed19.jpg";